import { realtimeEventSchema } from '../Types/events'

export function parseRealtimeEvent(message: string) {
    try {
        const parsed = JSON.parse(message) as unknown
        const result = realtimeEventSchema.safeParse(parsed)

        return result.success ? result.data : null
    } catch {
        return null
    }
}
